import { jsx as s } from "react/jsx-runtime";
import { useHorizonSvgBaseURL as c } from "../core/HorizonProvider/Horizon.context.js";
const l = {
  sm: 16,
  md: 24,
  lg: 32
};
function v(i) {
  return "variant" in i && i.variant !== void 0;
}
function g({ name: i, version: o, ...t }) {
  const { size: e, ...n } = t;
  let a = c();
  v(t) ? (a += `/${o}/${i}/${t.variant}/${e}.svg#root`, n == null || delete n.variant) : a += `/${o}/${i}/${e}.svg#root`;
  const r = l[e];
  return /* @__PURE__ */ s(
    "svg",
    {
      fill: "none",
      height: r,
      width: r,
      "aria-hidden": !0,
      ...n,
      children: /* @__PURE__ */ s("use", { href: a })
    }
  );
}
export {
  g as SvgIconBase
};
